import Contact from "./ContactContainer";

export default Contact;
